export const NOTIFICATION = "NOTIFICATION";
export const UPDATE_NOTIFICATION = "UPDATE_NOTIFICATION";
export const NOTIFICATIONS = "NOTIFICATIONS";
export const ATTACHMENTS_TYPES = "ATTACHMENTS_TYPES";
export const RESET_URLS = "RESET_URLS"
export const CREATE_NOTIFICATION_ATTACHMENTS = "CREATE_NOTIFICATION_ATTACHMENTS"
export const CREATE_NOTIFICATION = "CREATE_NOTIFICATION"
export const CREATE_WORK_FLOW_STEP = "CREATE_WORK_FLOW_STEP"
export const NOTIFICATIONS_ONCE = "NOTIFICATIONS_ONCE"
export const UPDATE_WORK_FLOW_STEP = "UPDATE_WORK_FLOW_STEP"
export const CREATE_REPORT = "CREATE_REPORT"
export const UPDATE_REPORT = "UPDATE_REPORT"
export const DELETE_NOTIFICATION = "DELETE_NOTIFICATION"
export const SHARE_NOTIFICATION = "SHARE_NOTIFICATION"

export const AUFGABE_NOTIFICATIONS = "AUFGABE_NOTIFICATIONS"

export const ASSIGN_NOTIFICATIONS = "ASSIGN_NOTIFICATIONS";



export const getall = (data,op) => {
  return {
    type: NOTIFICATIONS,
    payload:data,
    optype:op
  };
};

export const getallNotisForAufgabe = (data,op) => {
  return {
    type: AUFGABE_NOTIFICATIONS,
    payload:data,
    optype:op
  };
};

export const assignNotifications = (data,op) => {
  return {
    type: ASSIGN_NOTIFICATIONS,
    payload:data,
    optype:op
  };
};


export const getallOnce = (data,op) => {
  return {
    type: NOTIFICATIONS_ONCE,
    payload:data,
    optype:op
  };
};
export const getNotification = (data,op) => {
  return {
    type: NOTIFICATION,
    payload:data,
    optype:op
  };
};

export const CreateNotification = (data,op) => {
  return {
    type: CREATE_NOTIFICATION,
    payload:data,
    optype:op
  };
};

export const UpdateNotification = (data,op) => {
  return {
    type: UPDATE_NOTIFICATION,
    payload:data,
    optype:op
  };
};
export const DeleteNotification = (data) => {
  return {
    type: DELETE_NOTIFICATION,
    payload:data
  };
};
export const ShareNotification = (data,op) => {
  return {
    type: SHARE_NOTIFICATION,
    payload:data,
    optype:op
  };
};

export const CreateNotificatoinAttachments = (data) => {
  return {
    type: CREATE_NOTIFICATION_ATTACHMENTS,
    payload:data
  };
};

export const getAttachments = (data,op) => {
  return {
    type: ATTACHMENTS_TYPES,
    payload:data,
    optype:op
  };
};

export const resetUrls = () => {
  return {
    type: RESET_URLS
  };
};

export const CreateWorkFlowStep = (data) => {
  return {
    type: CREATE_WORK_FLOW_STEP,
    payload:data
  };
};


export const UpdateWorkFlowStep = (data,op) => {
  return {
    type: UPDATE_WORK_FLOW_STEP,
    payload:data,
    optype:op
  };
};

export const CreateReport = (data) => {
  return {
    type: CREATE_REPORT,
    payload:data
  };
};

export const UpdateReport = (data,op) => {
  return {
    type: UPDATE_REPORT,
    payload:data,
    optype:op
  };
};